module.exports = __webpack_public_path__ + "img/vip-study@2x.1db0d460.png";